<mat-sidenav-container class="sidenav-container">
  <mat-sidenav *ngIf="!isCompanyAdmin" mode="side" [opened]="true" [class.collapsed]="collapsed" class="custom-sidenav">
    <app-teacher-sidenavbar [collapsed]="collapsed" (toggle)="toggleSidenav()"></app-teacher-sidenavbar>
  </mat-sidenav>

  <mat-sidenav *ngIf="isCompanyAdmin" mode="side" [opened]="true" [class.collapsed]="collapsed" class="custom-sidenav recruiter-sidenav">
    <app-recruiter-sidebar [isCollapsed]="collapsed" [activeTab]="activeTab" (activeTabChange)="setActiveTab($event)" (toggleCollapse)="toggleSidenav()" (logout)="logout()"></app-recruiter-sidebar>
  </mat-sidenav>

  <mat-sidenav-content [ngStyle]="{ 'margin-left': (collapsed ? '4.5rem' : '15rem') }">
    <router-outlet></router-outlet>
  </mat-sidenav-content>
</mat-sidenav-container>